import { useSelector } from "react-redux";
import GullLayout from "app/GullLayout/GullLayout";
import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLoggedIn, userLoggedOut } from "app/redux/auth/authSlice";
import sessionStorageService from "app/services/sessionStorageService";
import Forbidden from "app/views/sessions/Forbidden";
import RegistrationReminderAlert from "app/views/app/contact/RegistrationReminder";

const AuthGuard = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Controlla lo stato di autenticazione quando cambia il pathname
    const data = sessionStorageService.getItem("auth_user");
    if (data) {
      if (!data.accessToken) {
        dispatch(userLoggedOut());
        return;
      }
      const tokenParts = data.accessToken.split('.');
      if (tokenParts.length === 3) {
        const payload = JSON.parse(atob(tokenParts[1]));
        const tokenExpirationDate = new Date(payload.exp * 1000);
        const currentDate = new Date();
        if (currentDate > tokenExpirationDate) {
          // Il token è scaduto
          dispatch(userLoggedOut());
        }
        else {
          dispatch(
            userLoggedIn({
              accessToken: data.accessToken,
              user: data,
            })
          );
        }
      } else {
        dispatch(userLoggedOut());
      }
    }
    setLoading(false);
  }, [dispatch, pathname]);

  // Mostra uno schermo di caricamento durante il recupero dei dati utente
  if (loading) {
    return <div>Loading...</div>;
  }
  // Elenca i ruoli consentiti per le route
  const allowedRolesForRoutes = {
    "dashboard": ["SUPERADMIN", "FSE"],
    "marketing": ["SUPERADMIN", "MARKETING"],
    "accettazione": ["SUPERADMIN", "ADMIN", "ACCETTAZIONE", "FSE"],
    "listino": ["SUPERADMIN", "ADMIN", "ACCETTAZIONE", "FSE"],
    "movimenti-cassa": ["SUPERADMIN", "ADMIN", "ACCETTAZIONE"],
    "contabilita": ["SUPERADMIN", "ADMIN"],
    "statistiche": ["SUPERADMIN", "ADMIN", "STATISTICHE"],
    "refertazione": ["SUPERADMIN", "ADMIN", "REFERTAZIONE", "FSE"],
    "tabelle": ["SUPERADMIN", "ADMIN", "TABELLE"],
    "utenti": ["SUPERADMIN", "ADMIN"],
    "opzioni": ["SUPERADMIN", "ADMIN"],
    "campagne-marketing": ["SUPERADMIN", "ADMIN"],
    "template-whatsapp": ["SUPERADMIN", "ADMIN"],
    // qui ci devono sempre essere tutti i ruoli, in quanto main poi ti fa da gateway su dove andare.
    "main": ["SUPERADMIN", "ADMIN", "REFERTAZIONE", "ACCETTAZIONE", "STATISTICHE", "CUP ADMIN", "FSE", "MARKETING"],
    "user-profile": ["SUPERADMIN", "ADMIN", "REFERTAZIONE", "ACCETTAZIONE", "STATISTICHE", "CUP ADMIN"],
    "info-account": ["SUPERADMIN", "ADMIN", "FSE"],
    "ElencoAcquisti": ["SUPERADMIN", "ADMIN", "STATISTICHE", "FSE"],
    "info-azienda": ["SUPERADMIN", "ADMIN", "FSE"],
    "InfoPaziente": ["SUPERADMIN", "ADMIN", "FSE"],
    "cup": ["SUPERADMIN", "ADMIN", "CUP ADMIN"],
  };

  const isAuthorized = () => {
    const rootPath = pathname.split("/")[1]; // Estrapola il primo segmento dalla route
    const allowedRoles = allowedRolesForRoutes[rootPath];
    if (allowedRoles) {
      let verificaRuolo = user.user.ruoli.some((userRole) => allowedRoles.includes(userRole));
      return verificaRuolo;
    }
    return false;
  };

  if (isAuthenticated) {
    if (isAuthorized()) {
      return (
        <GullLayout>
          <RegistrationReminderAlert />
          <Outlet />
        </GullLayout>
      );
    } else {
      // Utente autenticato ma senza autorizzazione per questa route
      return (
        <GullLayout>
          <Forbidden></Forbidden>
        </GullLayout>
      );
    }
  } else {
    return <Navigate to="/login" replace={true} />;
  }
};

export default AuthGuard;
